import { Component, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from "./service/app.layout.service";
import { AppTopBar2Component } from './app.topbar2.component';

@Component({
  selector: 'app-layout2',
  templateUrl: './app.layout2.component.html'
})
export class AppLayout2Component implements OnInit {

  @ViewChild(AppTopBar2Component) appTopbar!: AppTopBar2Component;

  constructor(public layoutService: LayoutService) {}

  ngOnInit() {
    document.body.style.backgroundImage = "";
    document.body.style.backgroundColor = "#A7ABF7";
  }

  get containerClass() {
    return {
      'layout-theme-light': this.layoutService.config().colorScheme === 'light',
      'layout-theme-dark': this.layoutService.config().colorScheme === 'dark',
      'layout-overlay': this.layoutService.config().menuMode === 'overlay',
      'layout-static': this.layoutService.config().menuMode === 'static',
      'layout-static-inactive': this.layoutService.state.staticMenuDesktopInactive && this.layoutService.config().menuMode === 'static',
      'layout-overlay-active': this.layoutService.state.overlayMenuActive,
      'layout-mobile-active': this.layoutService.state.staticMenuMobileActive,
      'p-input-filled': this.layoutService.config().inputStyle === 'filled',
      'p-ripple-disabled': !this.layoutService.config().ripple
    }
  }

}
